/** Arabic Lab playback mirrors Dawwin Flashcards' working voice fallback.
 * Browsers may expose no Arabic voice while still accepting an ar-SA utterance.
 */
export type SpeechResult={ok:boolean;message:string}
let active:SpeechSynthesisUtterance|null=null
let pendingVoiceWait:ReturnType<typeof setTimeout>|null=null
let pendingListener:(()=>void)|null=null
export function getArabicVoices():SpeechSynthesisVoice[]{
 if(typeof window==='undefined'||!('speechSynthesis' in window))return []
 return window.speechSynthesis.getVoices().filter(v=>/^ar(?:-|$)/i.test(v.lang))
}
export function speakArabic(text:string,rate=.7):SpeechResult{
 if(typeof window==='undefined'||!('speechSynthesis' in window)||typeof SpeechSynthesisUtterance==='undefined')
  return {ok:false,message:'Speech synthesis is not supported by this browser.'}
 const value=text.trim()
 if(!value)return {ok:false,message:'There is no Arabic text to read aloud.'}
 const engine=window.speechSynthesis
 if(pendingVoiceWait!==null){clearTimeout(pendingVoiceWait);pendingVoiceWait=null}
 if(pendingListener){engine.removeEventListener('voiceschanged',pendingListener);pendingListener=null}
 const play=()=>{
  const voices=engine.getVoices()
  const voice=voices.find(v=>/^ar-SA$/i.test(v.lang))||voices.find(v=>/^ar(?:-|$)/i.test(v.lang))
  try{
   engine.cancel()
   const utterance=new SpeechSynthesisUtterance(value)
   utterance.lang=voice?.lang||'ar-SA'
   if(voice)utterance.voice=voice
   utterance.rate=Math.min(1.2,Math.max(.5,rate))
   utterance.pitch=1
   utterance.volume=1
   active=utterance
   utterance.onend=()=>{if(active===utterance)active=null}
   utterance.onerror=()=>{if(active===utterance)active=null}
   engine.speak(utterance)
   if(engine.paused)engine.resume()
  }catch{active=null}
 }
 // Chrome may populate its voice list after a user gesture. Keep the
 // flashcards' ar-SA fallback even if no Arabic voice is enumerated.
 if(engine.getVoices().length){play()}
 else{
  let started=false
  const ready=()=>{
   if(started)return
   started=true
   if(pendingVoiceWait!==null){clearTimeout(pendingVoiceWait);pendingVoiceWait=null}
   if(pendingListener){engine.removeEventListener('voiceschanged',pendingListener);pendingListener=null}
   play()
  }
  pendingListener=ready
  engine.addEventListener('voiceschanged',ready,{once:true})
  pendingVoiceWait=setTimeout(ready,500)
 }
 return {ok:true,message:''}
}
export function whenArabicVoicesReady(callback:()=>void):()=>void{
 if(typeof window==='undefined'||!('speechSynthesis' in window))return ()=>{}
 const engine=window.speechSynthesis
 engine.getVoices()
 engine.addEventListener('voiceschanged',callback)
 return ()=>engine.removeEventListener('voiceschanged',callback)
}
